var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "main" }, [
    _c("h4", [_vm._v("Our members:")]),
    _vm._v(" "),
    _c(
      "table",
      { staticClass: "table-people" },
      [
        _c("tr", { staticClass: "table-people__row" }, [
          _c(
            "th",
            {
              staticClass: "table-people__cell table-people_head",
              on: {
                click: function($event) {
                  return _vm.$emit("sortPersons", "id")
                }
              }
            },
            [
              _vm._v("\n        #\n        "),
              _c("SortArrow", {
                attrs: { name: "id", sortBy: _vm.sortBy, asc: _vm.asc }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticClass: "table-people__cell table-people_head",
              on: {
                click: function($event) {
                  return _vm.$emit("sortPersons", "firstName")
                }
              }
            },
            [
              _vm._v("\n        First name\n        "),
              _c("SortArrow", {
                attrs: { name: "firstName", sortBy: _vm.sortBy, asc: _vm.asc }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticClass: "table-people__cell table-people_head",
              on: {
                click: function($event) {
                  return _vm.$emit("sortPersons", "lastName")
                }
              }
            },
            [
              _vm._v("\n        Last name\n        "),
              _c("SortArrow", {
                attrs: { name: "lastName", sortBy: _vm.sortBy, asc: _vm.asc }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.sortedPeople, function(person) {
          return _c("PeopleRow", { key: person.id, attrs: { person: person } })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-276cc548", { render: render, staticRenderFns: staticRenderFns })
  }
}